import burgerImg from '../../images/burger.png';
import cityTour from '../../images/city-tour.png';
import currencyCal from '../../images/currency-calculator.png';
import customMusicPlayer from '../../images/custom-music-player.png';
import customVideoPlayer from '../../images/custom-video-player.png';
import diceThrow from '../../images/dice-throw.png';
import expenseTracker from '../../images/expense-tracker.png';
import formValidator from '../../images/form-validator.png';
import hangman from '../../images/hangman.png';
import infiniteScrollBlog from '../../images/infinite-scroll-blog.png';
import landingPage from '../../images/landing-page.png';
import mealFinder from '../../images/meal-finder.png';
import memoryCards from '../../images/memory-card.png';
import myPortfolio from '../../images/my-portfolio.png';
import relaxer from '../../images/relaxer.png';
import searchLyrics from '../../images/search-lyrics.png';
import speechTextReader from '../../images/speech-text-reader.png';
import taskManager from '../../images/task-manager.png';
import treasureFindingApp from '../../images/treasure-finding-app.png';
import calculator from '../../images/calculator.png';
import carousel from '../../images/carousel.png';
import speedTyper from '../../images/speed-typer.png';
import tipCalculator from '../../images/tip-calculator.png';
import Wunderlist from '../../images/wunderlist-design-clone.png';
import instaCloneimg from '../../img/instaCloneImg.png';
import YoutubeCloneImg from '../../images/youtubeCloneImg.png';
import speakNumberGuessImg from '../../images/guessNumberImg.png';
import MovieSeatBookingImg from '../../img/movie-seat-booking-sc.png';
import GalleryImg from '../../images/GALLERY.png';
import SnakeGameImg from '../../images/snakeGameImg.png';
import MovieTrackImg from '../../images/movieTrackerImg.png';
import NetflixCloneImg from '../../images/netflixClone.png';
import AnalogClockImg from '../../images/analogClock.png';
import TailwindGalleryImg from '../../images/gallImg.png';
import quizBeeImg from '../../images/quizBeeImg.png';
import BreakingBadImg from '../../images/breakingBadImg.png';
import profileCardImg from '../../images/profileCard.png';
import NewyearCountDownImg from '../../images/NewyearCountDownImg.png';
import ChessBoardImg from '../../images/chessBoardGameIMg.png';

export const cardData = [
  {
    id: 1,
    img: burgerImg,
    name: 'Burger-E-Commerce-Application',
    info:
      'Burger E-commerce-Application, here you can make your own custom burger by adding ingredients and price will be add upon base price, and then add to cart and fill your contact details and address then place an order.',
    link: 'https://sriyat.github.io/',
  },
  {
    id: 2,
    img: speakNumberGuessImg,
    name: 'Speak Number Guess Game',
    info:
      "Speak Number Guess Game, It's a game, random numbers generates on each time you reload the page, you need to guess the number over speech, and it'll suggest you as per the number you need to guess higher than what you guessed or lower, once you guessed the correct number, it'll show you a congratulations message and asks to play again.",
    link: 'https://speak-number-guess-vjs.netlify.app/',
  },

  {
    id: 3,
    img: myPortfolio,
    name: 'My Portfolio',
    info:
      'My Portfolio, This is my portfolio application, which provides information about me, my projects with clickable links, my cv which is downloadable, my skills with brief and finally my socials which are also clickable.',
    link: 'https://my-portfolio-version1.netlify.app/',
  },
  {
    id: 4,
    img: customMusicPlayer,
    name: 'Custom Music Player',
    info:
      'Custom Music Player, a player where random 3 songs are there with a progress bar as like in music app, on scroll on left and right music plays accordingly with time stamp and can pause, play forward,play backward, or change the songs and stop it also.',
    link: 'https://music-player-v1.netlify.app',
  },
  {
    id: 5,
    img: customVideoPlayer,
    name: 'Custom Music player',
    info:
      'Custom Video Player, a Player where random video plays  with a progress bar as like in video player, on scroll on left and right music plays accordingly with time stamp and can pause, play forward,play backward, and stop it also.',
    link: 'https://custom-video-player-vjs.netlify.app',
  },
  {
    id: 6,
    img: diceThrow,
    name: 'Dice Throw',
    info:
      'Dice Throw, it is a dice throw game where  it display a card on click of play button it will display random numbers in between 1 to 6 as like the dice game in ludo.',
    link: 'https://dice-throw-react-application.netlify.app',
  },
  {
    id: 7,
    img: expenseTracker,
    name: 'Expense Tracker',
    info:
      'Expense Tracker, it is expense calculator application, where one can add his/her income and expense and it will calculate your total net worth and display along with all respective history of data. ',
    link: 'https://expense-tracker-react-application.netlify.app',
  },
  {
    id: 8,
    img: formValidator,
    name: 'Form Validator',
    info:
      'Form Validator, It is a basic form where there are text fields like username, email, password, confirm password and submit button, with standard validation respectively and display an appropriate error message.',
    link: 'https://form-validator-vjs.netlify.app',
  },
  {
    id: 9,
    img: hangman,
    name: 'Hangman',
    info:
      'Hangman, a word gaming where a different word will be generating, you need to guess the word by filling one by one letter, per one wrong letter guessing , there will a one body part of man will be hanging, if the man completely hung then your game is over otherwise you win if you guessed the correct before the man completely hung.',
    link: 'https://hangman-vjs.netlify.app',
  },
  {
    id: 10,
    img: infiniteScrollBlog,
    name: 'Infinite Scroll Blog',
    info:
      'Infinite Scroll Blog, a blog page where number of blogs are there but at a time paginated as to show only 10 blogs, and a spinner to optimization then next set of data to maintain pagination and following to that there is a search button where you can search with the keys and respective matching will display of max on screen at a time.',
    link: 'https://infinte-scroll-blog.netlify.app',
  },
  {
    id: 11,
    img: landingPage,
    name: 'Landing Page',
    info:
      'Landing Page, It has a header and body part, where some text shows and in header there is a signup button, on click of it it opens modal and there is side bar, A layout design of landing page.',
    link: 'https://modal-menu-sidebar.netlify.app',
  },
  {
    id: 12,
    img: mealFinder,
    name: 'Meal Finder',
    info:
      'Meal Finder, here  on search of any dish, on Screen respective recipe with image will display and if such dish not found then appropriate message will be shown saying that "There are no search results. Try again!", Also there is a button for random dishes with recipes.',
    link: 'https://meal-finder-vjs.netlify.app',
  },
  {
    id: 13,
    img: memoryCards,
    name: 'Memory Cards',
    info:
      'Memory Cards, Here you can type your new card and the info you can store on flip, like way you can keep multiple cards and display the respective card info on flip click, and you can clear all the cards on click of Clear Cards button.There is arrows for left and right scroll of cards to view cards, when we have multiple cards.',
    link: 'https://memory-cards-vjs.netlify.app',
  },
  {
    id: 14,
    img: currencyCal,
    name: 'Currency Calculator',
    info:
      'Currency Calculator, It is a currency rate calculator, choose a currency and enter amount and it will display you the chosen currency amount. And it will show the currency per 1selected currency value per the selected currency.',
    link: 'https://exchange-rate-calculator-vjs.netlify.app',
  },
  {
    id: 15,
    img: relaxer,
    name: 'Relaxer',
    info:
      'Relaxer, It is a breathe-in , hold and breathe-out app, where it actually shows for certain time breathe-in, and hold for certain time and then breathe-out, to feel relax with css Animation effect.',
    link: 'https://relaxer-app-vjs.netlify.app/',
  },
  {
    id: 16,
    img: searchLyrics,
    name: 'Search Lyrics',
    info:
      "Search Lyrics, It's Lyrics search application, where you can type a song name, on the screen the respective song's lyrics with album info will display. ",
    link: 'https://search-lyrics-react-app.netlify.app',
  },
  {
    id: 17,
    img: speechTextReader,
    name: 'Speech Text Reader',
    info:
      "Speech Text Reader, It's a speech reader application, by default there are some images with corresponding text on click of the text or image respective text will be said over mic and custom text also you can write and different voices from different region also you can choose. ",
    link: 'https://speech-text-reader.netlify.app/',
  },
  {
    id: 18,
    img: taskManager,
    name: 'Task Manager',
    info:
      "Task Manager, It's like a to-do app, as name suggests it manages the task, you can add your task and edit it and after finish you can delete it.",
    link: 'https://task-manager-react-code.netlify.app',
  },
  {
    id: 19,
    img: treasureFindingApp,
    name: 'Treasure Finding Gaming App',
    info:
      'Treasure Finding Gaming App, As name suggested you need to find the treasure box, there are many blocked trees and rocks, you need to choose the path to reach to treasure box.',
    link: 'https://treasure-finding-gaming-react-application.netlify.app',
  },
  {
    id: 20,
    img: calculator,
    name: 'Calculator',
    info:
      'Calculator, It works as a basic calculator, where you can perform arithmetic operations(as like addition, subtraction, multiplication, division) on numbers and it will display you with result.',
    link: 'https://calculator-vjs.netlify.app/',
  },
  {
    id: 21,
    img: carousel,
    name: 'Carousel',
    info:
      'Carousel, here we have specific places of images with corresponding text, on click of left arrow and right arrow buttons the images slides respective side with displays respective text for that image',
    link: 'https://carousel-vjs.netlify.app',
  },
  {
    id: 22,
    img: speedTyper,
    name: 'Speed Typer',
    info:
      "Speed Typer, It's a game , it suggests words every time you reload the page, so you need to type the word that displays on the screen, as per the level of game you have selected the extra timer will be added to your running time, and if the timer reaches to zero, as many words you have typed that will be your score.",
    link: 'https://speed-typing-game-vjs.netlify.app',
  },
  {
    id: 23,
    img: tipCalculator,
    name: 'Tip Calculator',
    info:
      "Tip Calculator, It's a calculator used for calculating tip, you need to enter number of persons and total bill , then it'll calculate the split amount to be paid by each person.",
    link: 'https://tip-calculator-vjs.netlify.app/',
  },
  {
    id: 24,
    img: Wunderlist,
    name: 'Wunderlist Design Clone',
    info:
      'Wunderlist Design Clone, As like to-do app, Wunderlist is also same kind of web-application, So It was my first html/css based application.',
    link: 'https://wunderlist-clone-design.netlify.app',
  },
  {
    id: 25,
    img: cityTour,
    name: 'City Tour',
    info:
      'City Tour, is a layout design where different cities image with information displayed as card, on click of info button information of particular city will be shown and on hover on the image, a times button appears, on click of it, it deletes the particular card. ',
    link: 'https://city-tour-react-code-app.netlify.app',
  },
  {
    id: 26,
    img: instaCloneimg,
    name: 'Instagram Clone',
    info:
      " Instagram Clone,It's a instagram clone design application using React.js",
    link: 'https://instagram-clone-app.netlify.app',
  },
  {
    id: 27,
    img: YoutubeCloneImg,
    name: 'Youtube Clone Application',
    info:
      'Youtube Clone Application, As like youtube, there are some sets default videos will be  displayed on the screen, and there is a search field, you can search for any videos of your choice, you will be seeing number of suggestion as per you search, and on click of any particular video, video will play, functions as similar as Youtube',
    link: 'https://youtube-clone-react-app-v1.netlify.app',
  },
  {
    id: 28,
    img: MovieSeatBookingImg,
    name: 'Movie Seat  Booking Application',
    info:
      'Movie Seat  Booking Application, As like online movie seat booking apps, it functions the same, it allows you to book a seat and it shows how many seats are reserved, it allows you to select a movie and displays the amount according to the movies and number of seats you have selected, as the way you can book you movie tickets.',
    link: 'https://movie-seats-booking-vjs.netlify.app',
  },
  {
    id: 29,
    img: GalleryImg,
    name: 'FireGram Gallery Application',
    info:
      'Gallery Application, You can upload your images and make your own beautiful gallery, there is a progress bar while uploading an image, it will show the progress of the image uploading through progress bar and once it is uploaded, image will be added to your gallery and on click of any image you can see respective full image.',
    link: 'https://my-gallery-react-app.netlify.app/',
  },
  {
    id: 30,
    img: SnakeGameImg,
    name: 'Snake Game Application',
    info:
      'Snake Game Application, snake can be move in any direction, you need to feed food by taking snake towards food, on each time it eats it grows a unit of length, it should not direct contact to boundary wall and should not eat it self, else game over with score how much snake ate, and you can play gain.',
    link: 'https://snake-game-react-app.netlify.app',
  },
  {
    id: 31,
    img: MovieTrackImg,
    name: 'Movie Tracker Application',
    info:
      'Movie Tracker Application, Here you can search for any movie, it will display result as per your search with respective movie image, imdb rating and some movie info.',
    link: 'https://movie-tracker-react-app.netlify.app',
  },
  {
    id: 32,
    img: NetflixCloneImg,
    name: 'Netflix Clone Application',
    info:
      'Netflix Clone Application, This is the netflix clone design application of signup page with similar view as netflix signup page.',
    link: 'https://netflix-clone-react-app.netlify.app',
  },
  {
    id: 33,
    img: AnalogClockImg,
    name: 'Analog Clock',
    info:
      'Analog Clock, it shows the analog time, with hour, minute, time hand and the date and day it will display with a proper analog watch view.',
    link: 'https://analog-clock-react-app.netlify.app',
  },
  {
    id: 34,
    img: TailwindGalleryImg,
    name: 'Gallery Application',
    info:
      'Gallery Application, By default there are many images on the screen , you also can search by typing in the search field and it will display as per you search .',
    link: 'https://react-tail-wind-gallery.netlify.app/',
  },
  {
    id: 35,
    img: quizBeeImg,
    name: 'Quiz Bee Application',
    info:
      'Quiz Bee Application, There are set of questions every time you reload the web page, there will be four options per question, you need to select an answer, on completion of each set of question it will show your score as per your answers selections, and you can play again with new set of questions.',
    link: 'https://quizbee-react-app.netlify.app',
  },
  {
    id: 36,
    img: BreakingBadImg,
    name: 'Breaking Bad Cast Application',
    info:
      'Breaking Bad Cast Application, It is a american web-series, so all cast image of these series are displayed in this application, on hover of each it will flip and show about respective cast info .',
    link: 'https://breaking-bad-cast-react-app.netlify.app/',
  },
  {
    id: 37,
    img: profileCardImg,
    name: 'Profile Card',
    info:
      'Profile Card, It is my profile card with my profile pic surrounded by a cool background image and some lines about me and my social links .',
    link: 'https://profile-card-react.netlify.app/',
  },
  {
    id: 38,
    img: NewyearCountDownImg,
    name: 'NewYear Countdown Application',
    info:
      'NewYear Countdown Application, It will show for the next year how many days , hours, minutes, seconds left from current date and time and in the background it will display the next year.',
    link: 'https://newyear-countdown-vjs.netlify.app',
  },
  {
    id: 39,
    img: ChessBoardImg,
    name: 'Chess Board Game',
    info:
      'Chess Board Game, It is a chess game, with the same view and pieces , you can play with the same chess rules.',
    link: 'https://chess-board-game.netlify.app',
  },
];
